import { useRef } from 'react';
import '../styles/BackedBy.css';

const BACKERS = [
  { id: 'reforge', name: 'Reforge', logo: '/images/reforge.png' },
  { id: 'dcg', name: 'DCG', logo: '/images/dcg.png' },
  { id: 'maven11', name: 'Maven11', logo: '/images/maven11.png' },
  { id: 'hashkey', name: 'HashKey Capital', logo: '/images/hashkeyy.png' },
  { id: 'gsr', name: 'GSR', logo: '/images/gsr.png' },
  { id: 'okkc', name: 'OKKC Global', logo: '/images/okkc.png' },
  { id: 'keyrock', name: 'Keyrock', logo: '/images/keyrock.png' },
  { id: 'tenity', name: 'Tenity', logo: '/images/tenity.png' },
  { id: 'crit', name: 'Crit Ventures', logo: '/images/crit-ventures.png' },
  { id: 'cluster', name: 'Cluster Capital', logo: '/images/cluster-capital.png' },
  { id: 'flowdesk', name: 'flowdesk', logo: '/images/flowdesk.png' },
  { id: 'auros', name: 'AUROS', logo: '/images/auros.png' },
  { id: 'g2', name: 'G-2 Group', logo: '/images/g2-group.png' },
];

export default function BackedBy({ zIndex }) {
  const trackRef = useRef(null);

  function scrollByCard(direction) {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('.backer-card');
    const step = card ? card.offsetWidth + 20 : 260;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  return (
    <section className="backed-by" style={{ zIndex }}>
      <div className="backed-by__bg" aria-hidden="true" />

      <div className="backed-by__topbar">
        <span className="backed-by__brand">Doppler.finance</span>
        <span className="backed-by__pill">
          <span className="backed-by__pill-brace">{'{'}</span>
          Backers
          <span className="backed-by__pill-brace">{'}'}</span>
        </span>
      </div>

      <h2 className="backed-by__heading">
        <span className="backed-by__bold">Backed</span> by
      </h2>

      {/* Desktop: horizontal scroll carousel + arrow controls */}
      <div className="backed-by__carousel">
        <div className="backed-by__track" ref={trackRef}>
          {BACKERS.map((b) => (
            <div key={b.id} className="backer-card">
              <img src={b.logo} alt={b.name} loading="lazy" />
            </div>
          ))}
        </div>
        <div className="backed-by__arrows">
          <button type="button" aria-label="Previous" onClick={() => scrollByCard(-1)}>←</button>
          <button type="button" aria-label="Next" onClick={() => scrollByCard(1)}>→</button>
        </div>
      </div>

      {/* Mobile: full stacked 2-column grid, no scroll/arrows needed */}
      <div className="backed-by__grid">
        {BACKERS.map((b) => (
          <div key={b.id} className="backer-card">
            <img src={b.logo} alt={b.name} loading="lazy" />
          </div>
        ))}
      </div>
    </section>
  );
}